'use strict';

import { connectRefinementList } from 'react-instantsearch-dom';

export default connectRefinementList(({ items, title, className, children }) => {
	return items.length ? <div className={ className }>{ children }</div> : null;
});
